import { useSnackbar } from 'notistack';

import { trpc } from '../../../trpc';
import { statusChangeErrorMessage } from '../../snackbars/updateStatusOfVeranstaltungSnackbars';

export function useVorschlaegeInAngebotUebertragenMutation() {
  const { enqueueSnackbar } = useSnackbar();
  const utils = trpc.useUtils();

  return trpc.leistung.vorschlaegeInAngebotUebertragen.useMutation({
    onError: () => {
      enqueueSnackbar(statusChangeErrorMessage, { variant: 'error', persist: true });
    },
    onSuccess: (result) => {
      void utils.durchgang.getDurchgangByAkaDurchgangId.invalidate();
      void utils.durchgang.getDurchgaengeByAkaProduktIds.invalidate();
      void utils.veranstaltung.getVeranstaltungByAkaVeranstaltungId.invalidate();
      void utils.veranstaltung.getVeranstaltungenByAkaProduktIds.invalidate();

      if (result.errorMessages.length > 0) {
        result.errorMessages.forEach((errorMessage) => {
          enqueueSnackbar(errorMessage, { variant: 'error', persist: true });
        });
        return;
      }

      if (result.successMessages.length > 0) {
        result.successMessages.forEach((successMessage) => {
          enqueueSnackbar(successMessage, { variant: 'success' });
        });
      }
    },
  });
}
